import { Checkbox } from "@components";
import { cn } from "@utils";
import EditorDropdown from "./EditorDropdown";

export default function ChannelDropdown({
  emailEnabled,
  smsEnabled,
  onToggle,
  variant = "inline",
  edited = false,
  disabled = false,
}) {
  const parts = [];
  if (emailEnabled) parts.push("Email");
  if (smsEnabled) parts.push("SMS");
  const displayText = parts.length
    ? parts.join(variant === "pill" ? " + " : " · ")
    : "No channels";

  const isOnlyChannel = (channel) =>
    (channel === "email" && emailEnabled && !smsEnabled) ||
    (channel === "sms" && smsEnabled && !emailEnabled);

  return (
    <EditorDropdown label={displayText} variant={variant} edited={edited} disabled={disabled}>
      <div className="px-4 py-2 text-xs font-semibold text-zinc-500 uppercase tracking-wide">
        Send via
      </div>
      <div
        role="button"
        onClick={() => !isOnlyChannel("email") && onToggle("email")}
        className={cn(
          "flex items-center rounded px-4 py-2 text-sm",
          isOnlyChannel("email")
            ? "text-zinc-400 cursor-default"
            : "text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 cursor-pointer",
        )}
      >
        <Checkbox
          readonly
          disabled={isOnlyChannel("email")}
          style={{ pointerEvents: "none" }}
          checked={emailEnabled}
          className="relative left-0 top-0 -mt-0"
        />
        <span className="ml-5 select-none">Email</span>
      </div>
      <div
        role="button"
        onClick={() => !isOnlyChannel("sms") && onToggle("sms")}
        className={cn(
          "flex items-center rounded px-4 py-2 text-sm",
          isOnlyChannel("sms")
            ? "text-zinc-400 cursor-default"
            : "text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 cursor-pointer",
        )}
      >
        <Checkbox
          readonly
          disabled={isOnlyChannel("sms")}
          style={{ pointerEvents: "none" }}
          checked={smsEnabled}
          className="relative left-0 top-0 -mt-0"
        />
        <span className="ml-5 select-none">SMS</span>
      </div>
    </EditorDropdown>
  );
}
